import actionType from "./actionType";
import {State} from "./state";
import { MenuItem } from "../../interface/Server";

export interface Action {
    type: actionType,
    payload: {
        menu?: MenuItem[],
        showLoading?: boolean,
        hasToken?: boolean,
        language?: string,
        debugMode?: boolean,
        publicKey?: string,
    }
}

const dispatch = (state: State, action: Action): State => {
    switch (action.type) {
        case actionType.SET_MENU_ITEMS: {
            return ({
                ...state,
                menu: action.payload.menu,
                language: action.payload.language,
            })
        }
        case actionType.SET_TOKEN_NOT_NULL: {
            return ({
                ...state,
                hasToken: action.payload.hasToken,
            })
        }
        case actionType.TOGGLE_LOADING: {
            return ({
                ...state,
                showLoading: action.payload.showLoading
            })
        }
        case actionType.SET_DEBUG_MODE: {
            return ({
                ...state,
                debugMode: action.payload.debugMode
            })
        }
        case actionType.SET_PUBLIC_KEY: {
            return ({
                ...state,
                publicKey: action.payload.publicKey
            })
        }
        default:
            return state
    }
};


export default dispatch

